<template>
  <div class="message-container">
    <emoji-message-template
      ref="form"
      v-model="form.message"
      :component-message="form.message"
      :max="msgLimit"
      :rules="'required|max:'+msgLimit"
      :placeholder="getReplyTrans('private_message_reply_hint')"
      show-max
    />
  </div>
</template>

<script>
import EmojiMessageTemplate from '@/@bya3/components/inputs/EmojiMessageTemplate'
import ReplyMixin from '../../mixins/reply-mixin'

export default {
  name: 'TextTemplate',
  components: { EmojiMessageTemplate },
  mixins: [ReplyMixin],
  computed: {
    msgLimit() {
      // eslint-disable-next-line no-nested-ternary
      return this.$store.getters['auth/isInstagram'] ? 1000 : (this.form.include_url ? 640 : 2000)
    },
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    async submit() {
      if (this.$refs.form?.$refs?.form) {
        const isValid = await this.$refs.form.$refs.form.validate()
        if (!isValid) throw new Error(this.$tc('errors.field-invalid', 1))
      }
    },
  },
}
</script>
